const state = {
  isDropdownOpened: false,
  devs: ''
};

const mutations = {
  SET_DROPDOWNOPENED: (state, idc) => {
    state.isDropdownOpened = idc;
  },
  SET_DEVS: (state, ds) => {
    state.devs = ds;
  }
};

const actions = {
  markdownDropdownOpened({ commit }, bol) {
    commit('SET_DROPDOWNOPENED', bol);
  },
  markdownDevs({ commit }, devs) {
    commit('SET_DEVS', devs);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
